<div class="citation-popover" [style.left.px]="positionX" [style.top.px]="positionY">
  <div class="citation-popover-header">
    {{ citation.title }}
    <button class="citation-popover-close" (click)="dismissed.emit()" aria-label="Close">&times;</button>
  </div>
  <div class="citation-popover-separator"></div>
  <div class="citation-popover-body">
    <button
      class="citation-chunk-btn"
      *ngFor="let chunk of sortedChunks"
      (click)="onChunkClick(chunk)"
    >
      <span class="chunk-page">Page {{ chunk.pageNumber }}</span>
      <span class="chunk-preview">{{ getPreview(chunk.searchText) }}</span>
    </button>
  </div>
</div>
